"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultFeatureFlagsWithOverrides = exports.FeatureFlagsContext = exports.defaultFeatureFlags = void 0;
var react_1 = __importDefault(require("react"));
exports.defaultFeatureFlags = {
    metricsDataCatalogEnabled: true,
    writableFieldDescriptionsEnabled: true,
    fieldDescriptionInheritanceLineageEnabled: true,
    publishedConnectionsLineageEnabled: true,
    databasesInProjectsEnabled: true,
    lensLineageEnabled: true,
    relevantAssetsEnabled: false,
    mixedContentConnectToDialogEnabled: false,
    sensitiveLabelsEnabled: false,
    labelsInMorePlacesEnabled: false,
};
exports.FeatureFlagsContext = react_1.default.createContext(exports.defaultFeatureFlags);
function defaultFeatureFlagsWithOverrides(overrides) {
    return __assign(__assign({}, exports.defaultFeatureFlags), overrides);
}
exports.defaultFeatureFlagsWithOverrides = defaultFeatureFlagsWithOverrides;
//# sourceMappingURL=FeatureFlagsContext.js.map